import * as React from 'react';
import { withTranslation } from 'react-i18next';
import ListItem from '@mui/material/ListItem';
import './_commentSection.scss';

export type CommentT = {
    author: {
        email: string;
    };
    content: string;
    date: string;
    id: number;
    inscription: {
        budgetLineSoftwareId: string;
        id: number;
    };
    lastItem?: boolean;
};

type Props = {
    showDeleteButton: boolean;
    t: TranslationT;
    deleteComment: FlowAnyFunction;
    comment: CommentT;
};
type State = {
    commentContent: string;
};

class Comment extends React.Component<Props, State> {
    deleteComment = () => {
        this.props.deleteComment(this.props.comment.id);
    };

    render() {
        const { showDeleteButton, comment } = this.props;

        return (
            <ListItem divider className="chart-comment">
                <div className="comment-author">{comment.author.email}</div>
                <div className="comment-content">{comment.content}</div>
                <div className="comment-footer">
                    <span className="comment-date">{comment.date}</span>
                    {showDeleteButton && (
                        <span
                            onClick={this.deleteComment}
                            className="comment-delete"
                            role="button"
                            tabIndex={0}
                        >
                            {this.props.t('common.delete') as string}
                        </span>
                    )}
                </div>
            </ListItem>
        );
    }
}
const TranslatedComment = withTranslation('components')(Comment);

TranslatedComment.displayName = 'Comment';
export default TranslatedComment;
